import { useDeviceLocation } from 'app/agriculture/queries/devices/useDeviceLocation';
import { ShowOnMapButton } from 'app/agriculture/components/ContentBox/components/ShowOnMapButton';

export function DeviceShowOnMapButton({ deviceId }: { deviceId: string }) {
    const location = useDeviceLocation({ deviceId });

    return <ShowOnMapButton position={location} />;
}
